var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.showMargin ? 'show-margin' : '',attrs:{"rel":"noopener","href":_vm.href}},[_c('img',{attrs:{"src":require("@/assets/images/whatsapp.svg"),"alt":"Whatsapp"}})])}
var staticRenderFns = []

export { render, staticRenderFns }